import api from "@/services/api";

export interface AuditLogEntry {
  id: number;
  userId: number;
  userEmail: string;
  userFullName: string;
  action: string;
  entityType: string | null;
  entityId: string | null;
  beforeValue: unknown;
  afterValue: unknown;
  details: string | null;
  createdAt: string;
}

export interface ListAuditLogParams {
  action?: string;
  entityType?: string;
  userId?: number;
  limit?: number;
  offset?: number;
  fromDate?: string;
  toDate?: string;
}

export interface ListAuditLogResult {
  entries: AuditLogEntry[];
  total: number;
}

export async function getAuditLog(params: ListAuditLogParams = {}): Promise<ListAuditLogResult> {
  const searchParams = new URLSearchParams();
  if (params.action) searchParams.set("action", params.action);
  if (params.entityType) searchParams.set("entityType", params.entityType);
  if (params.userId != null) searchParams.set("userId", String(params.userId));
  if (params.limit != null) searchParams.set("limit", String(params.limit));
  if (params.offset != null) searchParams.set("offset", String(params.offset));
  if (params.fromDate) searchParams.set("fromDate", params.fromDate);
  if (params.toDate) searchParams.set("toDate", params.toDate);
  const qs = searchParams.toString();
  const { data } = await api.get<ListAuditLogResult>(
    `/audit-log${qs ? `?${qs}` : ""}`
  );
  return data;
}
